// extracted by mini-css-extract-plugin
export default {"container":"NameInput_container__MHw0L","title":"NameInput_title__E1-Ih","input":"NameInput_input__Iv49W","error-message":"NameInput_error-message__19ttN"};